<template>
    <v-layout justify-center align-center>
        <h1>Company Manage Menu</h1>
    </v-layout>
</template>

<script>
  export default {
    name: 'CompanyManageMenu'
  }
</script>

<style scoped>

</style>
